import { useEffect } from "react";
import { AiOutlineClose } from "react-icons/ai";

import { useModal } from "../context/modal-context";

const Modal = () => {
  const {
    isModalVisible,
    modalContent,
    hideModal,
    modalLabel,
    modalFullScreen,
    modalOptions,
  } = useModal();

  useEffect(() => {
    // Empêcher le scroll du corps de la page derrière la modale
    const originalOverflow = document.body.style.overflow;
    if (isModalVisible) {
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [isModalVisible]);

  if (!isModalVisible) return null;

  const { hideHeader, closeOnOutsideClick } = modalOptions;

  return (
    <div
      className={`fixed inset-0 z-20 flex items-center justify-center ${
        hideHeader
          ? "bg-[rgba(13,13,13,0.21)]"
          : "bg-black bg-opacity-30 backdrop-blur-sm"
      }`}
      onClick={closeOnOutsideClick ? hideModal : undefined}
    >
      <div
        className={`bg-white rounded-[15px] overflow-auto max-h-[95%] max-w-[95%] relative ${
          hideHeader ? "shadow-[0px_4px_12px_0px_rgba(142,165,210,0.35)]" : "shadow-lg"
        } ${modalFullScreen ? "h-full w-full" : ""}`}
        onClick={(e) => e.stopPropagation()} // Empêche le clic de se propager au conteneur de fond
      >
        {!hideHeader && (
          <div className="flex items-center w-full p-3 border-b border-b-neutral-lighter">
            <label className="flex-1 font-semibold text-primary">
              {modalLabel ?? ""}
            </label>
            <AiOutlineClose
              className="cursor-pointer justify-self-end text-primary hover:text-light"
              size={24}
              onClick={hideModal}
            />
          </div>
        )}
        {modalContent}
      </div>
    </div>
  );
};

export default Modal;
